import React, { useState } from 'react';
import { Card, Col, Row, Form, Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import axiosInstance from 'utils/axiosInterceptors';
import { toastConfig } from 'utils/toastConfig';
import PageBreadcrumb from 'components/common/PageBreadcrumb';

const Marketing = () => {
  const [messageContent, setMessageContent] = useState('');
  const [sendToIndividualCustomers, setSendToIndividualCustomers] = useState(true);
  const [sendToCompanyCustomers, setSendToCompanyCustomers] = useState(false);
  const [sending, setSending] = useState(false);

  const handleSendMessage = async () => {
    if (!messageContent.trim()) {
      toast.error('Please enter a message to send', toastConfig);
      return;
    }

    setSending(true);
    try {
      await axiosInstance.post('/api/v1/marketing/sms/send', {
        MessageContent: messageContent.trim(),
        SendToIndividualCustomers: sendToIndividualCustomers,
        SendToCompanyCustomers: sendToCompanyCustomers
      });
      
      toast.success('Marketing message sent successfully!', {
        ...toastConfig,
        autoClose: 3000
      });
      
      // Clear the message after successful send
      setMessageContent('');
    } catch (error) {
      console.error('Error sending marketing message:', error);
      if (error instanceof AxiosError) {
        toast.error(
          error.response?.data?.errorMessage || 'Failed to send marketing message',
          {
            ...toastConfig,
            autoClose: 5000
          }
        );
      }
    } finally {
      setSending(false);
    }
  };

  const breadcrumbItems = [
    { label: 'Home', href: '/' },
    { label: 'Marketing', active: true }
  ];

  return (
    <div>
      <PageBreadcrumb items={breadcrumbItems} />
      <div className="mb-9">
        <h2 className="mb-5">Marketing Messages</h2>
        
        <Row className="justify-content-center">
          <Col lg={8} xl={6}>
            <Card>
              <Card.Header>
                <h5 className="mb-0">Send SMS Marketing Message</h5>
              </Card.Header>
              <Card.Body>
                <div className="mb-4">
                  <Form.Label htmlFor="marketing-message">
                    Marketing Message
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    id="marketing-message"
                    rows={6}
                    placeholder="Enter your marketing message here..."
                    value={messageContent}
                    onChange={(e) => setMessageContent(e.target.value)}
                    disabled={sending}
                  />
                  <Form.Text className="text-muted">
                    This message will be sent via SMS to the selected customer types.
                  </Form.Text>
                </div>

                <div className="mb-4">
                  <Form.Label className="mb-3">Send To:</Form.Label>
                  <div className="mb-2">
                    <Form.Check
                      type="checkbox"
                      id="send-to-individual"
                      label="Individual Customers"
                      checked={sendToIndividualCustomers}
                      onChange={(e) => setSendToIndividualCustomers(e.target.checked)}
                      disabled={sending}
                    />
                  </div>
                  <div className="mb-2">
                    <Form.Check
                      type="checkbox"
                      id="send-to-company"
                      label="Company Customers"
                      checked={sendToCompanyCustomers}
                      onChange={(e) => setSendToCompanyCustomers(e.target.checked)}
                      disabled={sending}
                    />
                  </div>
                  <Form.Text className="text-muted">
                    Select which customer types should receive the marketing message.
                  </Form.Text>
                </div>

                <div className="d-grid">
                  <Button
                    variant="primary"
                    size="lg"
                    onClick={handleSendMessage}
                    disabled={sending || !messageContent.trim() || (!sendToIndividualCustomers && !sendToCompanyCustomers)}
                  >
                    {sending ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          className="me-2"
                        />
                        Sending Message...
                      </>
                    ) : (
                      'Send Marketing Message'
                    )}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Marketing; 